export default __webpack_public_path__ + "static/media/01_DAIF_Data_04_02_loop.eb791d1d.mp4";